import { NotificationStatus } from "@/services/api/flightChanges/types";
import { notificationStatusMapper } from "@/services/api/flightChanges/mappers/statusMapper";
import { Text } from "@hangar/web-components/core/Text";
import * as S from "./styles/Notification.style";
import { useTranslation } from "../../hooks/i18n/useTranslation";
import { NotificationProps } from './types';

export const Notification = ({ notificationStatus, label }: NotificationProps) => {
  const { t } = useTranslation();

  const noNotificationContainer = (
    <S.Container>
      <Text variant="body-lg">-</Text>
    </S.Container>
  );



  if (!notificationStatus) {
    return noNotificationContainer;
  }

  const mappedStatus = notificationStatusMapper.map(notificationStatus);

  if (!mappedStatus) {
    return noNotificationContainer;
  }

  const isAtRisk = mappedStatus === NotificationStatus.AT_RISK;

  const riskTextContent = (
    <>
      <Text variant="body-lg" bold={true}>
        {t(mappedStatus)}
      </Text>
      <S.RiskDot />
    </>
  );

  return (
    <S.Container>
      <S.NotificationContainer>
        {isAtRisk ? riskTextContent : <Text variant="body-lg">{t(mappedStatus)}</Text>}
      </S.NotificationContainer>
      <Text variant="body-sm" color="secondary">{label}</Text>
    </S.Container>
  );
};